import axios from 'axios';

export default {
  methods: {
    async validateToken(code, provider, advanced = false) {
      if (provider === 'todoist') {
        const todoUrl = `/auth/todoist?code=${code}`;
        await axios.get(todoUrl);
        return;
      }

      const githubUrl = `/auth/github?code=${code}&advanced=${advanced}`;
      const response = await axios.get(githubUrl);
      const githubIntegration = Object.assign({}, response.data.integration);
      githubIntegration.active = true;
      this.$set(this.$store.state.integrations, 'Github', githubIntegration);
    },
    openSocialLoginWindow(socialUrl, redirectURl, provider, advanced) {
      // From http://www.gethugames.in/2012/04/authentication-and-authorization-for-google-apis-in-javascript-popup-window-tutorial.html
      function gup(url, nameInc) {
        const name = nameInc.replace(/[[]/, '\[').replace(/[]]/, '\]'); // eslint-disable-line
        const regexS = `[\?&]${name}=([^&#]*)`; // eslint-disable-line
        const regex = new RegExp(regexS);
        const results = regex.exec(url);
        if (results == null) return '';
        return results[1];
      }

      const win = window.open(socialUrl, 'oauth-window', 'width=500, height=500');
      const pollTimer = window.setInterval(() => {
        try {
          if (win.document.URL.indexOf(redirectURl) === -1) return;
          window.clearInterval(pollTimer);

          const windowUrl = win.document.URL;
          const code = gup(windowUrl, 'code');

          win.close();

          this.validateToken(code, provider, advanced);
        } catch(e) {} // eslint-disable-line
      }, 100);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/oauth.js